import React, { useCallback, useEffect, useState } from 'react'


import styles from '../../css/style.module.css'
import { RiDeleteBin6Line } from "react-icons/ri";
import { FaPlus } from "react-icons/fa6";


import HOC from '../../components/HOC/HOC'
import { IoSearchSharp } from "react-icons/io5";
import { AddOutfit, DeleteSuccessfullyModal, SuccessfullyModal } from '../../components/Modals/Modals';
import endPoints from '../../Repository/apiConfig';
import { deleteApi, getApi } from '../../Repository/Api';
import img2 from '../../assest/loading1.gif'

import { FaRegEdit } from "react-icons/fa";
import Pagination from '../../components/Pagination/Pagination';


const columns = [
  'S.no',
  'Dress Name',
  'Status',
  'Action'
];








const Outfit = () => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [dressdata, setDressData] = useState([])
  const [loading, setLoading] = useState(false);
  const [selecteddata, setSelectedData] = useState(null);

  const [showAddModal, setShowAddModal] = useState(false);
  const [editMode, setEditMode] = useState(false);

  const [search, setSearch] = useState('')
  const [pagination, setPagination] = useState({
    limit: 10,
    totalPages: 1,
    page: 1,
    hasPrevPage: false,
    hasNextPage: false,
  });


  const fetchData = useCallback(async () => {
    await getApi(endPoints.getalldress(pagination.page, pagination.limit, search), {
      setResponse: setDressData,
      setLoading,
      errorMsg: 'Failed to fetch dress!'
    });
  }, [pagination.page, pagination.limit, search]);

  useEffect(() => {
    setPagination((prevPagination) => ({
      ...prevPagination,
      totalPages: dressdata?.data?.totalPages,
      hasPrevPage: dressdata?.data?.hasPrevPage,
      hasNextPage: dressdata?.data?.hasNextPage,
    }));
  }, [dressdata]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);




  const handleDelete = async () => {
    if (!selecteddata) return;

    await deleteApi(endPoints.deletedress(selecteddata), {
      setLoading,
      // successMsg: 'Category deleted successfully!',
      errorMsg: 'Failed to delete outfit!'
    });

    fetchData();
    setShowDeleteModal(false);
    setShowSuccessModal(true);
    setTimeout(() => setShowSuccessModal(false), 2000);
  };

  const openDeleteModal = (id) => {
    setSelectedData(id);
    setShowDeleteModal(true); // Open confirm delete modal
};

  const openEditModal = (data) => {
    setSelectedData(data);
    setEditMode(true);
    setShowAddModal(true);
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setPagination({ ...pagination, page: 1 }); 
  };



  return (
    <>
      <DeleteSuccessfullyModal
        show={showDeleteModal}
        handleClose={() => setShowDeleteModal(false)}
        handleConfirm={handleDelete}
        text="delete outfit"
      />
      <SuccessfullyModal
        show={showSuccessModal}
        handleClose={() => setShowSuccessModal(false)}
        text="Successfully Deleted"
      />
      <AddOutfit
        show={showAddModal}
        onHide={() => setShowAddModal(false)}
        fetchdata={fetchData}
        data={selecteddata}
        edit={editMode}
      />
      <div className={styles.jobmanagementCotainer}>
        <div className={styles.jobtoppart}>
          <div className={styles.pagetitle}>
            <h6>Outfit Management</h6>
            <div className={styles.searchbarnav}>
              <IoSearchSharp color='#8A8A8A' size={20} />
              <input
                type="search"
                placeholder="Search"
                value={search}
                onChange={handleSearchChange}
              />
            </div>
          </div>
          <div className={styles.rightbuttons}>
            <div className={styles.rightbuttons2} onClick={() => {
              setEditMode(false);
              setShowAddModal(true);
            }}>
              <FaPlus color='#FFFFFF' />
              <p>Create Outfit</p>
            </div>
          </div>
        </div>
        <div className={styles.jobchildcontainer}>
          <div className={styles.tablecontainer}>
            <table className={styles.table1}>
              <thead>
                <tr>
                  {columns.map((label, index) => (
                    <th key={index} className={styles.tableHeader}>{label}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {loading ?
                  <tr>
                    <td colSpan="12" style={{ textAlign: "center", padding: "1rem" }}>
                      <img src={img2} alt="" width={100} height={100} />
                    </td>
                  </tr>
                  :
                  dressdata?.data?.docs?.length === 0 ?
                    <tr>
                      <td colSpan="12" style={{ textAlign: "center", padding: "1rem" }}>
                        No data available.
                      </td>
                    </tr>
                    :
                    dressdata?.data?.docs?.map((itme, rowIndex) => (
                      <tr key={rowIndex} className={styles.tableRow}>
                        <td className={styles.tableCell}>{rowIndex + 1}</td>
                        <td className={styles.tableCell}>
                          {itme.name}
                        </td>
                        <td className={styles.tableCell}
                          style={{
                            color:
                              itme.status ? '#00AD1D' :
                                '#FF0E0E',
                            fontWeight: '600'
                          }}>
                          {itme.status ? "Active" : "InActive"}
                        </td>
                        <td>
                          <div className={styles.tableaction}>
                            <FaRegEdit size={20} onClick={() => openEditModal(itme)} style={{ cursor: "pointer", color: "#e9b44a" }} />
                            <RiDeleteBin6Line size={20}
                              onClick={() => openDeleteModal(itme._id)}
                              style={{ cursor: "pointer", color: "#d9534f" }}
                            />
                          </div>
                        </td>
                      </tr>
                    ))
                }
              </tbody>
            </table>
          </div>

          <Pagination
            limit={pagination.limit}
            totalPages={pagination.totalPages}
            page={pagination.page}
            hasPrevPage={pagination.hasPrevPage}
            hasNextPage={pagination.hasNextPage}
            onPageChange={(newPage) => setPagination({ ...pagination, page: newPage })}
          />
        </div>

      </div >
    </>
  )
}

export default HOC(Outfit)
